<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import { usePageLoadingStore } from "../../../../../stores/pageLoading";

import JobFairCorpInfoTabView from "./JobFairCorpInfoTabView.vue";
import adminJobfairStateService from "../../../services/jobfair/adminJobfairStateService";
import JobFairCorpJobPostingsTabView from "./JobFairCorpJobPostingsTabView.vue";
import JobFairCorpIntvOffersTabView from './JobFairCorpIntvOffersTabView.vue';
import JobFairCorpJobApplicationsTabView from './JobFairCorpJobApplicationsTabView.vue';

const route = useRoute();
const loadingStore = usePageLoadingStore();
const { $toast } = getCurrentInstance().appContext.config.globalProperties;
const tabRef = ref(null);

// 상단 tab 옆 (count)
const totalCnt11 = ref(0);
const totalCnt12 = ref(0);
const totalCnt13 = ref(0);
const totalCnt14 = ref(0);

const tabOptions = computed(() => [
  { label: `기업정보(${totalCnt11.value})`, value: 'corp-info' },
  { label: `채용공고(${totalCnt12.value})`, value: 'job-postings' },
  { label: `입사지원(${totalCnt13.value})`, value: 'job-applications' },
  { label: `보낸 면접제안(${totalCnt14.value})`, value: 'sent-interview-offers' }
]);

const selectedTabValue = ref(tabOptions.value[0].value);

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set("tab2", tab.value);
  window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
};

// TAB 옆 count
const retrieveJobFairCorpCount = () => {
  loadingStore.loading = true;
  adminJobfairStateService.retrieveJobFairCorpCount()
    .then( async (res) => {
      loadingStore.loading = false;
      if (res.data.code.toLowerCase() === "success") {
        const result = res.data.result;
        totalCnt11.value = result.totalCnt11;
        totalCnt12.value = result.totalCnt12;
        totalCnt13.value = result.totalCnt13;
        totalCnt14.value = result.totalCnt14;
      }
    }).catch((res) => {
    loadingStore.loading = false;
    $toast("error", res);
  });
};

onMounted(() => {
  const tabFromQuery = route.query.tab2;
  if (tabFromQuery && tabOptions.value.some(opt => opt.value === tabFromQuery)) {
    selectedTabValue.value = tabFromQuery;

    if(tabRef.value) {
      tabRef.value.init(tabFromQuery);
    }
  } else {
    selectedTabValue.value = tabOptions.value[0].value;
    if(tabRef.value) {
      tabRef.value.init(tabOptions.value[0].value);
    }
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("tab2", tabOptions.value[0].value);
    window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
  }

  retrieveJobFairCorpCount();
});
</script>

<template>
  <div>
    <div class="tab-wrap">
      <KSATab
        ref="tabRef"
        :options="tabOptions"
        @change="onChangeTab"
        style="grid-template-columns: repeat(4, 1fr);"
      />
    </div>
    <div v-if="selectedTabValue === 'corp-info'">
      <JobFairCorpInfoTabView />
    </div>
    <div v-else-if="selectedTabValue === 'job-postings'">
      <JobFairCorpJobPostingsTabView />
    </div>
    <div v-else-if="selectedTabValue === 'job-applications'">
      <JobFairCorpJobApplicationsTabView />
    </div>
    <div v-else-if="selectedTabValue === 'sent-interview-offers'">
      <JobFairCorpIntvOffersTabView />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-wrap {
  margin-bottom: 20px;
}
</style>
